// File: frontend/src/theme/index.js
// Version: 2.0 (Phase I.3 Unified Design System)
// Description: Unified MUI theme built on design system semantic tokens (§I.3).

import { createTheme } from '@mui/material/styles';

export const appTheme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#20231F',         // --primary (§I.1)
        },
        secondary: {
            main: '#666D74',         // --text-muted (§I.1 AA-certified)
        },
        background: {
            default: '#F8F7F2',      // --surface (§I.1)
            paper: '#FFFFFF',        // --surface-raised (§I.1)
        },
        text: {
            primary: '#20231F',      // --text (§I.1)
            secondary: '#666D74',    // --text-muted (§I.1)
            disabled: '#8E8778',     // --border-strong (§I.1)
        },
        divider: '#E5E1D6',          // --border (§I.1)
        error: {
            main: '#B83A34',         // --danger (§I.1 AA-certified)
        },
        warning: {
            main: '#9A5B0C',         // --warning (§I.1 AA-certified)
        },
        success: {
            main: '#0B7A53',         // --success (§I.1 AA-certified)
        },
        info: {
            main: '#2F66C2',         // --info (§I.1 AA-certified)
        },
    },
    typography: {
        fontFamily: 'var(--font-ui, "Manrope", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif)',
        h1: { fontFamily: 'var(--font-display, "DM Serif Display", Georgia, serif)', fontWeight: 500 },
        h2: { fontFamily: 'var(--font-display, "DM Serif Display", Georgia, serif)', fontWeight: 500 },
        h3: { fontFamily: 'var(--font-display, "DM Serif Display", Georgia, serif)', fontWeight: 500 },
        h4: { fontFamily: 'var(--font-display, "DM Serif Display", Georgia, serif)', fontWeight: 500 },
        button: {
            fontFamily: 'var(--font-ui, "Manrope", sans-serif)',
            textTransform: 'none',
            fontWeight: 600,
        },
    },
    shape: {
        borderRadius: 8,
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 'var(--radius-md)',
                    fontFamily: 'var(--font-ui)',
                    textTransform: 'none',
                },
                containedPrimary: {
                    backgroundColor: 'var(--primary)',
                    color: 'var(--on-primary)',
                    '&:hover': {
                        backgroundColor: 'var(--text)',
                    },
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundColor: 'var(--surface-raised)',
                    color: 'var(--text)',
                    borderColor: 'var(--border)',
                },
            },
        },
    },
});

export const fitenkoTheme = appTheme;
export default appTheme;
